export default __webpack_public_path__ + "static/media/food.15c72e7d.svg";